import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';

import { GetParallelLines, FilterSpans } from '../../../helpers/spanHelpers';
import { CompareBounds } from '../../../helpers/poleHelpers';
import { FilterPoles } from '../../../helpers/poleHelpers';


class ProtectionWire extends Component {


    componentDidMount() {
        this.loadProtectionWires();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || CompareBounds(nextProps.zoomLevel, this.props.bounds, nextProps.bounds)
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showThirdLevel !== nextProps.showThirdLevel) {
            return true;
        }
        else return false;
    }

    componentDidUpdate(){
        this.loadProtectionWires();
    }

    loadProtectionWires = () => {
        let resultList = [];
        if (this.props.zoomLevel === 3 && this.props.showThirdLevel) {

            this.props.ohlsList.forEach(ohl => {
                const polesInRangeList = FilterPoles(ohl.stubovi, this.props.bounds);
                const spansInRangeList = FilterSpans(ohl.rasponi, this.props.bounds);

                let wires = this.getProtectivWires(polesInRangeList, spansInRangeList, ohl.protectivWires)
                    .map((wire, index) =>
                        <Polyline
                            key={String(index) + ohl.name + wire.phase}
                            path={wire.path}
                            clicable
                            name={wire.phase}
                            strokeOpacity={0.8}
                            strokeColor={wire.type === 'OPGW' ? '#e6e600' : wire.type === 'AlCu' ? '#1aff1a' : '#ffff00'}
                            onClick={this.props.onWireClick}
                            strokeWeight={2}
                            ohlName={ohl.name}
                            spanName={wire.spanName}
                            wireType={wire.type}
                        />
                    )

                resultList = resultList.concat(wires);
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }



    getProtectivWires = (poleList, spanList, wires = [{ type: 'OPGW', position: 'N' }, { type: 'AlCu', position: 'S' }]) => {

        let resultList = [];
        let pomerajZica;

        if (wires) {
            wires.filter(wire => wire.position).forEach(pw => {

                if (pw.position === 'N') {
                    pomerajZica = 0.000015
                }
                else {
                    pomerajZica = -0.000015;
                }

                GetParallelLines(poleList, spanList, pomerajZica).forEach(ps => {
                    resultList.push({ spanName: ps.spanName, type: pw.type, path: ps.path });
                });
            });

        }

        return resultList;
    }


    render() {
        return null;
    }
}

export default ProtectionWire;